import { Component } from '@angular/core';

/** Coquille hôte : barre de titre + détail produit bibliothèque. */
@Component({
  selector: 'app-product-detail-shell',
  template: '<app-title-section></app-title-section><router-outlet></router-outlet>'
})
export class ProductDetailShellComponent {}
